import PlacesAutocomplete from './PlacesAutocomplete';

export default PlacesAutocomplete;
